async function renderWishlistPage(swat) {
  /* Shopify MoneyFormat */
  function formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  const getLists = () => {
    return new Promise(async (resolve, reject) => {
      swat.fetchLists({
        callbackFn: function (lists) {
          resolve(lists);
        },
        errorFn: function (xhrObj) {
          reject(xhrObj);
        },
      });
    });
  };

  const getProductsfromList = (listid) => {
    return new Promise(async (resolve, reject) => {
      swat.fetchListCtx(
        { lid: listid },
        function (listContents) {
          resolve(listContents);
        },
        function (xhrObj) {
          reject(xhrObj);
        }
      );
    });
  };

  const getProductDetail = async (url) => {
    const req = await fetch(`${url}.js`);
    const res = await req.json();
    console.log(res,"resss");
    return res;
  };

  const fetchProductsData = async (products) => {
    let res = await Promise.all(products.map(async (pdp) => {
        const productData = await fetch(pdp.du.split('?')[0] + '.js');
        const jsonData = await productData.json();
        return jsonData;
    }))
    return res;
  }

  const showListings = (lists) => {
    let listHtml = ``;
    for (let i = 0; i < lists.length; i++) {
      let list = lists[i];
      let imgs = "";
      if (list["listcontents"].length > 0) {
        for (let j = 0; j < list["listcontents"].length; j++) {
          if (j <= 2) {
            const image = list["listcontents"][j]["iu"];
            imgs += `
            <div class="page-custom-wishlist-lists__column" aria-hidden="false" data-acsb-hidden="false">
              <img src="${image}" alt="${list["listcontents"][j]["dt"]}" class="page-custom-wishlist-lists__image" aria-hidden="false" data-acsb-hidden="false" role="presentation" />
            </div>`;
          }
        }
      } else {
        imgs += `<div class="page-custom-wishlist-lists__column" aria-hidden="false" data-acsb-hidden="false"><div class="page-custom-wishlist-lists__placeholder" aria-hidden="false" data-acsb-hidden="false"></div></div><div class="page-custom-wishlist-lists__overlay" aria-hidden="false" data-acsb-hidden="false"><p aria-hidden="false" data-acsb-hidden="false">This is an empty list!</p></div>`;
      }

      createListButtonHtml = `
        <button type="button" aria-label="Create New List"
          class="page-custom-wishlist__create page-custom-wishlist__create--desktop" data-acsb-clickable="true"
          data-acsb-navigable="true" data-acsb-now-navigable="true" role="button">
          Create New List
        </button>`; 

      listHtml += `
        <article class="page-custom-wishlist-lists__item" aria-hidden="false" data-acsb-hidden="false">
          <button
            type="button" aria-label="${list["lname"]}" class="page-custom-wishlist-lists__button"
           data-acsb-now-navigable="true" aria-hidden="false"
            data-acsb-hidden="false" role="button" data-lid="${list["lid"]}">
            <h2 class="page-custom-wishlist-lists__title" aria-hidden="false" data-acsb-hidden="false">
              ${list["lname"]}
            </h2>
            <p class="page-custom-wishlist-lists__count" aria-hidden="false" data-acsb-hidden="false">
              ${list["cnt"]} Products
            </p>
            <div class="page-custom-wishlist-lists__columns" aria-hidden="false" data-acsb-hidden="false">
              ${imgs}
            </div>
            <p class="page-custom-wishlist-lists__cta swym-wishlist-link-action" aria-hidden="false" data-acsb-hidden="false" data-lid="${list["lid"]}">
              View List
            </p>
          </button> 
          <button type="button" class="page-custom-wishlist-lists__share" data-acsb-clickable="true" data-listid="${list["lid"]}"
            data-acsb-navigable="true" data-acsb-now-navigable="true" aria-hidden="false" data-acsb-hidden="false"
            role="button">
            <span class="acsb-sr-only" data-acsb-sr-only="true" data-acsb-force-visible="true"
              aria-label=" Share " aria-hidden="false" data-acsb-hidden="false">
            </span>
            <img src="//cdn.shopify.com/s/files/1/0076/6040/4818/t/223/assets/icon-wishlist-share.svg?v=37539135126003131261656532748" alt="Share" aria-hidden="false" data-acsb-hidden="false" />
          </button>
        </article>`;
    }
    document.querySelector(".page-custom-wishlist-lists").innerHTML = `
    ${createListButtonHtml}
    <div class="page-custom-wishlist-lists__list" aria-hidden="false" data-acsb-hidden="false">
      ${listHtml}
    </div>
    <button type="button" aria-label="Create New List" class="page-custom-wishlist__create" data-acsb-clickable="true" data-acsb-navigable="true" tabindex="-1" data-acsb-now-navigable="false" aria-hidden="true" data-acsb-hidden="true">
      Create New List
    </button>`;
  };

  const showEmptyState = () => {
    let blankHtml = `
    <section class="page-custom-wishlist-empty"><p class="page-custom-wishlist__message">Love it? Add it to your wishlist</p> <a href="/collections/all" class="page-custom-wishlist__shop"><span>Start Shopping<i>»</i></span></a></section>`;

    $(".page-custom-wishlist-lists").html(blankHtml);
  };

  const generateHeader = async (getLid) => {
    let lists = await getLists();

    let listsHtml = "";
    let avatar = "";
    for (let i = 0; i < lists.length; i++) {
      const list = lists[i];
      listsHtml += `<option value="${list["lid"]}" ${
        list["lid"] == getLid ? "selected" : ""
      } data-name="${list["lname"]}">${list["lname"]} (${
        list["cnt"]
      })</option>`;

      if (list["listcontents"].length > 0) {
        avatar = `
        <div class="page-custom-wishlist-avatar__image" style="background-image: url('${list["listcontents"][0]["iu"]}');" aria-hidden="false" data-acsb-hidden="false"></div>`;
      }
    }
    let headerHtml = `
    <div class="page-custom-wishlist-menu" aria-hidden="false" data-acsb-hidden="false">
      <div class="page-custom-wishlist-menu__columns" aria-hidden="false" data-acsb-hidden="false">
        <div class="page-custom-wishlist-menu__column page-custom-wishlist-menu__column--content" aria-hidden="false"
          data-acsb-hidden="false">
          <div class="page-custom-wishlist-avatar" aria-hidden="false" data-acsb-hidden="false">
            ${avatar}
          </div>
          <div class="page-custom-wishlist-select" aria-hidden="false" data-acsb-hidden="false">
            <p class="page-custom-wishlist-select__title" aria-hidden="false" data-acsb-hidden="false">List</p> 
            <select
              class="page-custom-wishlist-select__input"
              data-acsb-now-navigable="true" aria-hidden="false" data-acsb-hidden="false" type="select-one"
              data-acsb-validation-uuid="awacbbz4qao" data-acsb-field-visible="true" aria-label="List Back"
              placeholder="List Back" data-acsb-tooltip="List Back">
              ${listsHtml}
            </select>
          </div>
        </div>
        <div class="page-custom-wishlist-menu__column page-custom-wishlist-menu__column--menu" aria-hidden="false"
          data-acsb-hidden="false">
          <button type="button" data-wishlist-options="" class="page-custom-wishlist-menu__options"
            data-acsb-now-navigable="true" aria-hidden="false"
            data-acsb-hidden="false" role="button">
            <span class="acsb-sr-only" data-acsb-sr-only="true"
              data-acsb-force-visible="true" aria-label=" Open menu " aria-hidden="false"
              data-acsb-hidden="false">
            </span> 
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="5px" height="20px" viewBox="0 0 5 20"
              xml:space="preserve" aria-hidden="true" data-acsb-hidden="true" data-acsb-force-hidden="true">
              <g fill="#000000">
                <ellipse transform="matrix(0.9871 -0.1602 0.1602 0.9871 -1.5695 0.5296)" cx="2.5" cy="10" rx="2.18"
                  ry="2.18"></ellipse>
                <circle cx="2.5" cy="17.82" r="2.18"></circle>
                <circle cx="2.5" cy="2.179" r="2.179"></circle>
              </g> 
            </svg>
          </button>
          <div class="page-custom-wishlist-menu-dropdown">
            <div class="page-custom-wishlist-menu-dropdown__item">
              <button type="button" aria-label="Share"
                class="page-custom-wishlist-menu-dropdown__button"
                tabindex="-1" data-acsb-now-navigable="false" data-listid="${getLid}">
                Share
              </button>
            </div>
            <div class="page-custom-wishlist-menu-dropdown__item">
              <button type="button" aria-label="Add all to bag"
                class="page-custom-wishlist-menu-dropdown__button"
                tabindex="-1" data-acsb-now-navigable="false">
                Add all to bag
              </button>
            </div>
            <div class="page-custom-wishlist-menu-dropdown__item">
              <button type="button" aria-label="Clear all"
                class="page-custom-wishlist-menu-dropdown__button"
                tabindex="-1" data-acsb-now-navigable="false" data-listid="${getLid}">
                Clear all
              </button>
            </div>
            <div class="page-custom-wishlist-menu-dropdown__item">
              <button type="button" aria-label="Duplicate List"
                class="page-custom-wishlist-menu-dropdown__button"
                tabindex="-1" data-acsb-now-navigable="false">
                Duplicate List
              </button>
            </div>
            <div class="page-custom-wishlist-menu-dropdown__item">
              <button type="button" aria-label="Delete List"
                class="page-custom-wishlist-menu-dropdown__button"
                tabindex="-1" data-acsb-now-navigable="false" data-listid="${getLid}">
                Delete List
              </button>
            </div>
          </div>
        </div>
      </div>
      <button type="button" aria-label="Back" class="page-custom-wishlist-menu__back" data-acsb-clickable="true"
        data-acsb-navigable="true" data-acsb-now-navigable="true" aria-hidden="false" data-acsb-hidden="false"
        role="button">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" width="11px" height="11px" viewBox="0 0 11 11" xml:space="preserve" aria-hidden="true"
          data-acsb-hidden="true" data-acsb-force-hidden="true">
          <g fill="#231f20">
            <path
              d="M4.234,0L0.377,5.369v0.261L4.234,11h1.863L2.713,5.507L6.097,0H4.234z M8.759,0L4.903,5.369v0.261L8.759,11h1.863L7.239,5.507L10.623,0H8.759z">
            </path>
          </g>
        </svg>
        <span aria-hidden="false" data-acsb-hidden="false">Back</span>
      </button>
    </div>`;

    return headerHtml;
  };

  const generateProductCard = async (products) => {
    let currencyRate = Math.round(Shopify.currency.valueOf().rate);
    if (products.length > 0) {
      let productsHtml = "";
      for (let i = 0; i < products.length; i++) {
        const product = products[i];
        console.log(product, "phroduxt");
        const apiProduct = await getProductDetail(product["du"]);
        let optionsHtml = "";

        let isAvailable = true;

        for (let j = 0; j < apiProduct.variants.length; j++) {
          const variant = apiProduct.variants[j];
          optionsHtml += `<option value="${variant.id}" ${
            variant.id == product.epi ? "selected=selected" : ""
          } data-price="${variant.price}" data-compare="${
            variant.compare_at_price
          }" data-availibility="${
            variant.inventory_quantity > 0 ? true : false
          }" data-title="${variant.title}">${variant.title}</option>`;

          if (variant.id == product.epi && variant.inventory_quantity == 0)
            isAvailable = false;
        }

        productsHtml += ` 
        <figure class="page-custom-wishlist__item product-tile" aria-hidden="false" data-acsb-hidden="false">
          <button type="button" class="close-button remove-item page-custom-wishlist__wishlist" data-acsb-clickable="true" data-acsb-navigable="true" data-varid="${
            product.epi
          }" data-prodid="${product.empi}" data-du="${product.du}" data-lid="${
          product.lid
        }" data-acsb-now-navigable="true" aria-hidden="false" data-acsb-hidden="false" role="button">
            <span class="acsb-sr-only"
              data-acsb-sr-only="true" data-acsb-force-visible="true" aria-label=" Remove item " aria-hidden="false"
              data-acsb-hidden="false">
            </span>
            <img
              src="//cdn.shopify.com/s/files/1/0076/6040/4818/t/223/assets/icon-wishlist.svg?v=38444882934994986461656532748"
              alt="Wishlist Heart Icon" height="18" width="21" class="page-custom-wishlist__wishlist-icon" aria-hidden="true"
              data-acsb-hidden="true" 
            /> 
           
              <svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"  alt="Wishlist Heart Icon" height="18" width="18" class="page-custom-wishlist__wishlist-icon-active" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:svg="http://www.w3.org/2000/svg" id="svg1" viewBox="0 0 475.82 442.01" version="1.0">
            <g id="layer1" transform="translate(-134.07 -225.8)">
              <path id="path7" d="m263.42 235.15c-66.24 0-120 53.76-120 120 0 134.75 135.93 170.08 228.56 303.3 87.57-132.4 228.56-172.85 228.56-303.3 0-66.24-53.76-120-120-120-48.05 0-89.4 28.37-108.56 69.18-19.16-40.81-60.52-69.18-108.56-69.18z" stroke="#000" stroke-width="18.7" fill="#CC0000"/>
             </g>
            
          </button>
          <a href="${product["du"]}" aria-label="${
          product["dt"]
        }" class="page-custom-wishlist__image-holder product-tile__image-holder">
            <img src="${product["iu"]}" alt="${
          product["dt"]
        }" class="page-custom-wishlist__image product-tile__image"/>
          </a>
          <figcaption class="page-custom-wishlist__info" aria-hidden="false" data-acsb-hidden="false">
            <div class="page-custom-wishlist__info-inner" aria-hidden="false" data-acsb-hidden="false">
              <h3 class="page-custom-wishlist__name" aria-hidden="false" data-acsb-hidden="false">
                <a href="${product["du"]}" aria-label="${
          product["dt"]
        }" aria-hidden="false">
                  ${product["dt"]}
                </a>
              </h3>
              <div class="page-custom-wishlist__price page-custom-wishlist__price--mobile acsb-sr-only" aria-hidden="false"
                data-acsb-hidden="false" data-acsb-sr-only="true" data-acsb-force-visible="true">
                <span class="money">${Shopify.currency.active + " " + (apiProduct["price"]/100).toFixed(2)}</span>
              </div>
              <select class="variant-selector" data-size-select="0" type="select-one">
                ${optionsHtml}
              </select>
            </div>
            <div class="page-custom-wishlist__price page-custom-wishlist__price--no-mobile" aria-hidden="false"
              data-acsb-hidden="false">
              <span class="money" aria-hidden="false" data-acsb-hidden="false">
                ${Shopify.currency.active + " " + (apiProduct["price"]/100).toFixed(2)}
              </span>
            </div>
          </figcaption> 
          <button type="button" class="page-custom-wishlist__cta" role="button">
            <span
              class="add-to-bag page-custom-wishlist__cta-text page-custom-wishlist__cta-text--${
                isAvailable ? "enabled" : "disabled"
              }" data-varid="${
          product.epi
        }" data-availibilty="${isAvailable}" aria-hidden="false"
              data-acsb-hidden="false" >
              Add to my Bag
            </span> 
            <span
              class="notify-me page-custom-wishlist__cta-text page-custom-wishlist__cta-text--${
                !isAvailable ? "enabled" : "disabled"
              } acsb-sr-only" aria-hidden="false"
              data-acsb-hidden="false" data-acsb-sr-only="true" data-acsb-force-visible="true">
              Sold out</span>
            </span>
          </button>
        </figure>`;
      }

      return productsHtml;
    } else {
        $(".page-custom-wishlist-lists").addClass("empty-lists");
        return `<section class="page-custom-wishlist-empty"><p class="page-custom-wishlist__message">Love it? Add it to your wishlist</p> <a href="/collections/all" class="page-custom-wishlist__shop"><span>Start Shopping<i>»</i></span></a></section>`;
    }
  };

  const generateSflProductCard = async (products) => {
    let currencyRate = Math.round(Shopify.currency.valueOf().rate);
    const shopifyProductsData = await fetchProductsData(products);
    if (products.length > 0) {
      let productsHtml = `<div class="page-custom-wishlist__list product-tiles">`;
      products.forEach(async (product, index) => {
        // for (let i = 0; i < products.length; i++) {
          // const product = products[i];
          const apiProduct = shopifyProductsData[index];
          let optionsHtml = "";
  
          const selectedVariant = apiProduct.variants.find(variant => variant.id === product.epi);
          let isAvailable = selectedVariant.available;
  
          productsHtml += ` 
          <figure class="page-custom-wishlist__item product-tile sfl-item" aria-hidden="false" data-acsb-hidden="false">
            <button type="button" class="close-button remove-item page-custom-wishlist__wishlist" data-acsb-clickable="true" data-acsb-navigable="true" data-varid="${
              product.epi
            }" data-prodid="${product.empi}" data-du="${product.du}" data-lid="${
            product.lid
          }" data-acsb-now-navigable="true" aria-hidden="false" data-acsb-hidden="false" role="button">
              <span class="acsb-sr-only"
                data-acsb-sr-only="true" data-acsb-force-visible="true" aria-label=" Remove item " aria-hidden="false"
                data-acsb-hidden="false">
              </span>

              <svg class="page-custom-wishlist__wishlist-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#fff" d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/></svg>

               <svg class="page-custom-wishlist__wishlist-icon-active" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#c00" d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"/></svg>
              
            </button>
            <a href="${product["du"]}" aria-label="${
            product["dt"]
          }" class="page-custom-wishlist__image-holder product-tile__image-holder">
              <img src="${product["iu"]}" alt="${
            product["dt"]
          }" class="page-custom-wishlist__image product-tile__image"/>
            </a>
            <figcaption class="page-custom-wishlist__info" aria-hidden="false" data-acsb-hidden="false">
              <div class="page-custom-wishlist__info-inner" aria-hidden="false" data-acsb-hidden="false">
                <h3 class="page-custom-wishlist__name" aria-hidden="false" data-acsb-hidden="false">
                  <a href="${product["du"]}" aria-label="${
            product["dt"]
          }" aria-hidden="false">
                    ${product["dt"]}
                  </a>
                </h3>
                <div class="page-custom-wishlist__price page-custom-wishlist__price--mobile acsb-sr-only" aria-hidden="false"
                  data-acsb-hidden="false" data-acsb-sr-only="true" data-acsb-force-visible="true">
                  <span class="money">${Shopify.currency.active + " " + (apiProduct["price"]/100).toFixed(2)}</span>
                </div>
              </div>
              <div class="page-custom-wishlist__price page-custom-wishlist__price--no-mobile" aria-hidden="false"
                data-acsb-hidden="false">
                <span class="money" aria-hidden="false" data-acsb-hidden="false">
                  ${Shopify.currency.active + " " + (apiProduct["price"]/100).toFixed(2)}
                </span>
              </div>
            </figcaption> 
            <button type="button" class="page-custom-wishlist__cta sfl-item" role="button">
              <span
                class="add-to-bag page-custom-wishlist__cta-text page-custom-wishlist__cta-text--${
                  isAvailable ? "enabled" : "disabled"
                }" data-varid="${
            product.epi
          }" data-availibilty="${isAvailable}" aria-hidden="false"
                data-acsb-hidden="false" >
                Add to my Bag
              </span> 
              <span
                class="notify-me page-custom-wishlist__cta-text page-custom-wishlist__cta-text--${
                  !isAvailable ? "enabled" : "disabled"
                } acsb-sr-only" aria-hidden="false"
                data-acsb-hidden="false" data-acsb-sr-only="true" data-acsb-force-visible="true">
                Sold out</span>
              </span>
            </button>
          </figure>`;
      })
      productsHtml += '</div>';
      return productsHtml;
    } else {
        $(".page-custom-sfl-lists").addClass("empty-lists");
        $(".page-custom-sfl-lists").html('');
        return `
          <section class="page-custom-wishlist-empty">
            <p class="page-custom-wishlist__message">No Items saved yet. Save Items for Later from the Cart.</p>
            <a href="javascript:void(0)" onclick="openCartDrawer()" class="page-custom-wishlist__shop"><span>Open Cart Page<i>»</i></span></a>
          </section>`;
    }
  };

  window.openCartDrawer = (evt) => {
    document.dispatchEvent(new CustomEvent("cart:build"));
    $("#CartDrawer").addClass("drawer--is-open");
    $(".appear-animation").css("opacity", 1);
    $(".appear-animation").css("transform", "translateY(0px)");
    $(".pb").load(" .pb > *");
    $("#cart_ship").load(" #cart_ship > *");
    $("#cart--count").load(" #cart--count > *");
  }

  const listModalHtml = async () => {
    const lists = await getLists();
    let listsHtml = "";
    for (let i = 0; i < lists.length; i++) {
      const list = lists[i];

      let imageHtml = "";
      if (list["listcontents"].length != 0) {
        imageHtml = `<img src="${list["listcontents"][0]["iu"]} " alt="${list["lname"]}" role="presentation" />`;
      } else {
        imageHtml = `<span class="page-custom-wishlist-modal__item-no-image">${list[
          "lname"
        ].substring(0, 2)}</span>`;
      }
      listsHtml += `
      <div class="page-custom-wishlist-modal__item">
        <div class="page-custom-wishlist-modal__item-avatar">
          ${imageHtml}
        </div>
        <h3 class="page-custom-wishlist-modal__item-title">
          ${list["lname"]} (${list["cnt"]})
        </h3>
      </div>`;
    }

    $(
      ".swym-create-list-modal-container .page-custom-wishlist-modal__lists .swym-lists-wrapper"
    ).html(listsHtml);
    return true;
  };

  // Create List Modal
  $("body").delegate(".page-custom-wishlist__create", "click", async (evt) => {
    await listModalHtml();
    document
      .querySelector(
        ".swym-create-list-modal-container .page-custom-wishlist-modal"
      )
      .classList.add("active", "acsb-active");
  });

  // Login Modal
  $("body").delegate(".swym-user-login-btn", "click", (evt) => {
    document
      .querySelector(".swym-modal-login-container .page-custom-wishlist-modal")
      .classList.add("active", "acsb-active");
  });

  // Close Modals
  $("body").delegate(
    ".page-custom-wishlist-modal__close , .close-modal",
    "click",
    () => {
      $(
        "swym-modals .swym-custom-modal-container .page-custom-wishlist-modal"
      ).removeClass(["active", "acsb-active"]);
      // createPopup.classList.remove("active", "acsb-active");
      // loginpopup.classList.remove("active" ,"acsb-active");
      // document.querySelector(".swym-share-modal .page-custom-wishlist-modal").classList.remove("active", "acsb-active");
    }
  );

  // Share Modal
  $("body").delegate(
    ".page-custom-wishlist-lists__share ,.page-custom-wishlist-menu-dropdown__button[aria-label='Share']",
    "click",
    (evt) => {
      document
        .querySelector(".swym-share-modal .page-custom-wishlist-modal")
        .classList.toggle("active", "acsb-active");
      $(
        ".swym-share-modal .page-custom-wishlist-modal input[name='share-modal']"
      ).val($(evt.currentTarget).attr("data-listid"));
    }
  );

  // Duplicate list Modal
  $("body").delegate(
    ".page-custom-wishlist-menu .page-custom-wishlist-menu-dropdown .page-custom-wishlist-menu-dropdown__item button[aria-label='Duplicate List']",
    "click",
    (evt) => {
      document
        .querySelector(".swym-duplicate-list .page-custom-wishlist-modal")
        .classList.toggle("active", "acsb-active");
    }
  );

  // Delete List Modal
  $("body").delegate(
    ".page-custom-wishlist-menu .page-custom-wishlist-menu-dropdown .page-custom-wishlist-menu-dropdown__item button[aria-label='Delete List']",
    "click",
    (evt) => {
      document
        .querySelector(".swym-delete-list .page-custom-wishlist-modal")
        .classList.toggle("active", "acsb-active");
    }
  );

  // View list products
  $("body").delegate(
    "article .swym-wishlist-link-action , article .page-custom-wishlist-lists__button",
    "click",
    async (evt) => {
      let getLid = $(evt.currentTarget).attr("data-lid");

      let products = await getProductsfromList(getLid);
      let headerHtml = await generateHeader(getLid);
      let productCardsHtml = await generateProductCard(products);

      let pageHtml =
        headerHtml +
        `<div class="page-custom-wishlist__list product-tiles">${productCardsHtml}</div>`;
      $("section.page-custom-wishlist-lists").html(pageHtml);

      $("html, body").animate(
        {
          scrollTop: $(".swym-wishlist-outer-container header").offset().top,
        },
        "slow"
      );
    }
  );

  // Custom inner Header List change
  $("body").delegate(
    ".page-custom-wishlist-menu .page-custom-wishlist-select select",
    "change",
    async (evt) => {
      let getLid = $(evt.currentTarget).val();

      let products = await getProductsfromList(getLid);
      let headerHtml = await generateHeader(getLid);
      let productCardsHtml = await generateProductCard(products);

      let pageHtml =
        headerHtml +
        `<div class="page-custom-wishlist__list product-tiles">${productCardsHtml}</div>`;
      $("section.page-custom-wishlist-lists").html(pageHtml);
    }
  );

  // varinat change
  $("body").delegate("select.variant-selector", "change", (evt) => {
    /* 
      1) Remove Icon Nu variant change
      2) Add to cart ma variant id change
      3) remove old variant and add new variant
      4) check availibility and change the Notify me data
    */

    changeVariantId(evt.currentTarget);
    swymVariantChange(evt.currentTarget);
    chnageACTbuttons(evt.currentTarget);
    changePrice(evt.currentTarget);
  });

  // Inner page custom menu open
  $("body").delegate(".page-custom-wishlist-menu__options", "click", (evt) => {
    $(evt.currentTarget)
      .siblings(".page-custom-wishlist-menu-dropdown")
      .toggleClass("active");
  });

  const changeVariantId = (selector) => {
    // Close icon variant id change
    $(selector)
      .parents("figure")
      .find("button.close-button")
      .attr("data-varid", $(selector).val());
    $(selector)
      .parents("figure")
      .find("button.close-button")
      .attr(
        "data-availibilty",
        $(selector).find("option:selected").attr("data-availibility")
      );

    // Add to cart Variant id change
    $(selector)
      .parents("figcaption.page-custom-wishlist__info")
      .siblings(".page-custom-wishlist__cta")
      .find(".add-to-bag")
      .attr("data-varid", $(selector).val());
    $(selector)
      .parents("figcaption.page-custom-wishlist__info")
      .siblings(".page-custom-wishlist__cta")
      .find(".add-to-bag")
      .attr(
        "data-availibilty",
        $(selector).find("option:selected").attr("data-availibility")
      );
  };

  const swymVariantChange = (selector) => {
    return true;
  };

  const chnageACTbuttons = (selector) => {
    if (
      $(selector).find("option:selected").attr("data-availibility") == "true"
    ) {
      if (
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".add-to-bag")
          .hasClass("page-custom-wishlist__cta-text--disabled")
      ) {
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".add-to-bag")
          .removeClass("page-custom-wishlist__cta-text--disabled")
          .addClass("page-custom-wishlist__cta-text--enabled");
      }

      if (
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".notify-me")
          .hasClass("page-custom-wishlist__cta-text--enabled")
      ) {
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".notify-me")
          .removeClass("page-custom-wishlist__cta-text--enabled")
          .addClass("page-custom-wishlist__cta-text--disabled");
      }
    } else {
      if (
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".notify-me")
          .hasClass("page-custom-wishlist__cta-text--disabled")
      ) {
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".notify-me")
          .removeClass("page-custom-wishlist__cta-text--disabled")
          .addClass("page-custom-wishlist__cta-text--enabled");
      }

      if (
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".add-to-bag")
          .hasClass("page-custom-wishlist__cta-text--enabled")
      ) {
        $(selector)
          .parents(".page-custom-wishlist__info")
          .siblings(".page-custom-wishlist__cta")
          .find(".add-to-bag")
          .removeClass("page-custom-wishlist__cta-text--enabled")
          .addClass("page-custom-wishlist__cta-text--disabled");
      }
    }
  };

  const changePrice = (selector) => {
    $(selector)
      .parent()
      .siblings(".page-custom-wishlist__price span.money")
      .text(
        formatMoney(
          $(selector).find("option:selected").attr("data-price") * 100,
          theme.settings.moneyFormat
        )
      );
  };

  const openTab = tabType => {
    $(`[data-tab]:not([data-tab="${tabType}"])`).removeClass('active-tab');
    $(`[data-tab="${tabType}"]`).addClass('active-tab');
    $(`.list-containers:not(.page-custom-${tabType}-lists)`).addClass('swym-hide-container');
    $(`.page-custom-${tabType}-lists`).removeClass('swym-hide-container');
    if(tabType == 'sfl'){
      $(".page-custom-wishlist-lists button.page-custom-wishlist-menu__back").trigger("click");
      swat.fetchSFLList({},
        async function(sflData){
          let productCardsHtml = await generateSflProductCard(sflData.items);
          $('.page-custom-sfl-lists').html(productCardsHtml);
        },
        err => console.log('Unable to Fetch SFL list ', + err)
      )
    }
  }

  //  Add WL Product to cart and open a drawer.
  $("body").delegate(
    "button.page-custom-wishlist__cta:not(.sfl-item) .add-to-bag",
    "click",
    async (evt) => {
      let varid = $(evt.currentTarget).attr("data-varid");
      let cartObj = { id: varid, quantity: 1 };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: cartObj,
        dataType: "json",
        success: function (data) {
          openCartDrawer();
        },
      });
    }
  );

  //  Add SFL Product to cart and open a drawer.
  $("body").delegate(
    "button.page-custom-wishlist__cta.sfl-item .add-to-bag",
    "click",
    async (evt) => {
      let varid = $(evt.currentTarget).attr("data-varid");
      let cartObj = { id: varid, quantity: 1 };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: cartObj,
        dataType: "json",
        success: function (data) {
          openCartDrawer();
          console.log(evt.currentTarget.closest('.page-custom-wishlist__item.sfl-item'));
          evt.currentTarget.closest('.page-custom-wishlist__item.sfl-item').querySelector('.close-button').click();
        },
      });
    }
  );

  // Add All Product to cart and open a drawer
  $("body").delegate(
    ".page-custom-wishlist-menu-dropdown .page-custom-wishlist-menu-dropdown__button[aria-label='Add all to bag']",
    "click",
    (evt) => {
      let items = [];
      $(
        ".page-custom-wishlist__list.product-tiles figure.page-custom-wishlist__item.product-tile"
      ).each((ind, ele) => {
        if (
          $(ele)
            .find("button.page-custom-wishlist__cta .add-to-bag")
            .attr("data-availibilty") == "true"
        ) {
          items.push({
            id: $(ele)
              .find("button.page-custom-wishlist__cta .add-to-bag")
              .attr("data-varid"), // VariantId
            quantity: 1,
          });
        }
      });
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: items },
        dataType: "json",
        success: function (data) {
          document.dispatchEvent(new CustomEvent("cart:build"));
          $("#CartDrawer").addClass("drawer--is-open");
          $(".appear-animation").css("opacity", 1);
          $(".appear-animation").css("transform", "translateY(0px)");
        },
      });
    }
  );

  // Back Button click
  $("body").delegate(
    ".page-custom-wishlist-menu__back",
    "click",
    async (evt) => {
      const lists = await getLists();
      showListings(lists);
    }
  );

  // Send Mail
  $("body").delegate(
    ".page-custom-wishlist-modal__submit-holder .page-custom-wishlist-modal__submit.send-mail",
    "click",
    (evt) => {
      let sendMailObj = {
        toEmailId: $(
          "form.page-custom-wishlist-modal__form #share-recipient-email"
        ).val(),
        fromName: $(
          "form.page-custom-wishlist-modal__form #share-sender"
        ).val(),
        note: $("form.page-custom-wishlist-modal__form #share-message").val(),
        lid: $(
          ".swym-share-modal .page-custom-wishlist-modal.active input[name='share-modal']"
        ).val(),
      };

      swat.sendListViaEmail(
        sendMailObj,
        function (r) {
          console.log("Email sent!");
          $(".swym-share-modal form button.send-mail")
            .parent()
            .before(
              `<p class="page-custom-wishlist-modal__error">List emailed successfully.</p>`
            );
          setTimeout(() => {
            $(".page-custom-wishlist-modal__close").trigger("click");
            $(".swym-share-modal form input").val("");
            $(".swym-share-modal form textarea").val("");
            $(
              ".swym-share-modal form .page-custom-wishlist-modal__error"
            ).remove();
          }, 1000);
        },
        function (r) {
          console.log("Email failed!");
        }
      );
    }
  );

  // Copy Link Functionality
  $("body").delegate(
    ".page-custom-wishlist-modal__submit-holder .page-custom-wishlist-modal__submit-outline.copy-link",
    "click",
    (evt) => {
      let listId = $(
        ".swym-share-modal .page-custom-wishlist-modal.active input[name='share-modal']"
      ).val();

      swat.generateSharedListURL(
        listId,
        function (data, listId) {
          $(
            ".page-custom-wishlist-modal__submit-holder input.copy-link-url"
          ).val(data);
          let copyValue = document.querySelector(
            ".page-custom-wishlist-modal__submit-holder input.copy-link-url"
          ).value;
          navigator.clipboard.writeText(copyValue);
        },
        function (data) {
          console.log(data);
        }
      );
    }
  );

  // create wishlist input field keyup
  $("body").delegate(
    "form.page-custom-wishlist-modal__create-form .page-custom-wishlist-modal__item input#create-name",
    "keyup",
    (evt) => {
      if ($(evt.currentTarget).val().length > 3) {
        $(evt.currentTarget)
          .parents(".page-custom-wishlist-modal__item")
          .siblings("button.page-custom-wishlist__create")
          .removeAttr("disabled");
      } else {
        $(evt.currentTarget)
          .parents(".page-custom-wishlist-modal__item")
          .siblings("button.page-custom-wishlist__create")
          .attr("disabled", true);
      }
    }
  );

  // Duplicate List Modal input
  $("body").delegate(
    "form.page-custom-wishlist-modal__form input#wishlist-name",
    "keyup",
    (evt) => {
      if ($(evt.currentTarget).val().length > 3) {
        $(evt.currentTarget)
          .siblings(".page-custom-wishlist-modal__submit-holder-double")
          .find("button.page-custom-wishlist-modal__submit")
          .removeAttr("disabled");
      } else {
        $(evt.currentTarget)
          .siblings(".page-custom-wishlist-modal__submit-holder-double")
          .find("button.page-custom-wishlist-modal__submit")
          .attr("disabled", true);
      }
    }
  );

  // Create a new List
  $("body").delegate(
    "form.page-custom-wishlist-modal__create-form .page-custom-wishlist__create--submit",
    "click",
    (evt) => {
      let ListName = $(evt.currentTarget)
        .siblings(".page-custom-wishlist-modal__item")
        .find("input#create-name")
        .val();
      swat.createList(
        { lname: ListName },
        function (list) {
          let listHtml = `
      <div class="page-custom-wishlist-modal__item">
        <div class="page-custom-wishlist-modal__item-avatar">
          <span class="page-custom-wishlist-modal__item-no-image">${list[
            "lname"
          ].substring(0, 2)}</span>
        </div>
        <h3 class="page-custom-wishlist-modal__item-title">
          ${list["lname"]} (0)
        </h3>
      </div>`;
          $(
            ".swym-create-list-modal-container .page-custom-wishlist-modal__lists .swym-lists-wrapper"
          ).append(listHtml);
          $(evt.currentTarget)
            .siblings(".page-custom-wishlist-modal__item")
            .find("input#create-name")
            .val("");
          $(evt.currentTarget).attr("disabled", true);
        },
        function (xhrObject) {
          // something went wrong
          console.log(xhrObject);
        }
      );
    }
  );

  // Remove WL Item
 $(document).on("click", ".page-custom-wishlist__item.product-tile:not(.sfl-item) button.remove-item", (evt) => {
   let removeWishlistProduct = {
     epi: $(evt.currentTarget).attr("data-varid"),
     empi: $(evt.currentTarget).attr("data-prodid"),
     du: $(evt.currentTarget).attr("data-du"),
   };
   swat.deleteFromList($(evt.currentTarget).attr("data-lid"), removeWishlistProduct, function(deletedListItem) {
     let listName = $("select.page-custom-wishlist-select__input option:selected").attr("data-name");
     let count = parseInt($(".header__icon--wishlist-badge-text.show-badge").attr("data-count")) - 1;
     $("select.page-custom-wishlist-select__input option:selected").text(`${listName} (${count})`);
     $(evt.currentTarget).parent().remove();
   }, function(xhrObj) {
     // something went wrong
     console.log(xhrObj);
   });
 });

   // Remove SFL Item
   $(document).on("click", ".page-custom-wishlist__item.product-tile.sfl-item button.remove-item", (evt) => {
    const product = { 
      "SFLProductList":[{ 
        "epi": $(evt.currentTarget).attr("data-varid"), 
        "du": $(evt.currentTarget).attr("data-du"), 
        "empi": $(evt.currentTarget).attr("data-prodid")
      }], 
      "lid": swat.sflLid 
    };
    const onSuccess = async deletedProduct => {
      console.log('deletedProduct - ', deletedProduct);
      $(evt.currentTarget).parent().remove();
      console.log(document.querySelectorAll('.page-custom-wishlist__item.product-tile.sfl-item').length);
      if(!document.querySelectorAll('.page-custom-wishlist__item.product-tile.sfl-item').length){
        const productCardsHtml = await generateSflProductCard([]);
        $('.page-custom-sfl-lists').html(productCardsHtml);
      }
    }

    const onError = error => console.log("Error while deleting the Product", error);

    swat.removeFromSFL(product, onSuccess, onError);
  });

  // Clear all Products
  $("body").delegate(
    ".page-custom-wishlist-menu-dropdown .page-custom-wishlist-menu-dropdown__button[aria-label='Clear all']",
    "click",
    (evt) => {
      let prodObj = [];

      $(
        ".page-custom-wishlist__list.product-tiles figure.page-custom-wishlist__item.product-tile"
      ).each((ind, ele) => {
        prodObj.push({
          epi: $(ele).find("button.close-button").attr("data-varid"), // VariantId
          empi: $(ele).find("button.close-button").attr("data-prodid"), //ProductId
          du: $(ele).find("button.close-button").attr("data-du"), //Product Url
        });
      });

      swat.removeProductsFromList(
        $(evt.currentTarget).attr("data-listid"),
        prodObj,
        function (resp) {
          $(
            ".page-custom-wishlist-lists button.page-custom-wishlist-menu__back"
          ).trigger("click");
          document.dispatchEvent(new CustomEvent("swym:counter"));
        },
        function (xhrObject) {
          console.log(xhrObject);
        }
      );
    }
  );

  // Delete a list
  $("body").delegate(
    ".swym-delete-list button.page-custom-wishlist-modal__submit",
    "click",
    (evt) => {
      swat.deleteList(
        $(
          ".page-custom-wishlist-menu-dropdown__item  .page-custom-wishlist-menu-dropdown__button[aria-label='Delete List']"
        ).attr("data-listid"),
        async function (deletedListObj) {
          // successfully deleted list
          document.dispatchEvent(new CustomEvent("swym:counter"));
          $(".page-custom-wishlist-modal__close").trigger("click");
          $(
            ".page-custom-wishlist-lists button.page-custom-wishlist-menu__back"
          ).trigger("click");
          const lists = await getLists();
          if(lists.length == 0) showEmptyState();
        },
        function (xhrObject) {
          // something went wrong
          console.log(xhrObject);
        }
      );
    }
  );

  // Duplicate List
  $("body").delegate(
    ".swym-duplicate-list .page-custom-wishlist-modal__form .page-custom-wishlist-modal__submit[aria-label='Duplicate list']",
    "click",
    (evt) => {
      let listName = $(evt.currentTarget)
        .parent(".page-custom-wishlist-modal__submit-holder-double")
        .siblings("input#wishlist-name")
        .val();

      let prodObj = [];

      $(
        ".page-custom-wishlist__list.product-tiles figure.page-custom-wishlist__item.product-tile"
      ).each((ind, ele) => {
        prodObj.push({
          epi: $(ele).find("button.close-button").attr("data-varid"), // VariantId
          empi: $(ele).find("button.close-button").attr("data-prodid"), //ProductId
          du: $(ele).find("button.close-button").attr("data-du"), //Product Url
        });
      });

      // Create a list
      swat.createList(
        { lname: listName },
        function (newListObj) {
          const listId = newListObj.lid;
          swat.addProductsToList(
            listId,
            prodObj,
            function (resp) {
              // document.dispatchEvent(new CustomEvent('swym:counter'));
              $(".page-custom-wishlist-modal__close").trigger("click");
              $(
                ".page-custom-wishlist-lists button.page-custom-wishlist-menu__back"
              ).trigger("click");
            },
            function (xhrObject) {
              // something went wrong
              console.log("Error in Duplicating lists", xhrObject);
            }
          );
        },
        function (xhrObject) {
          // something went wrong
          console.log("Error in creating in a list", xhrObject);
        }
      );
    }
  );

  const SFLFeatureEnabled = swat.retailerSettings?.SFL?.SFLFeatureEnabled || false; 
  if(SFLFeatureEnabled){
    $('header.page-custom-wishlist-header').addClass('swym-sfl-enabled');
    $('h2.page-custom-wishlist-header__title').addClass('swym-sfl-enabled');
    $('.page-custom-wishlist-header__user').addClass('swym-sfl-enabled');
    $('.page-custom-wishlist-tab__button').addClass('active-tab');
    $('.page-custom-sfl-tab__button').removeClass('swym-hide-container');
    // Tab Buttons click
    $("body").delegate(
      ".page-custom-wishlist-header__title button",
      "click",
      (evt) => {
        if(evt.currentTarget.classList.contains('active-tab')) return;
        openTab(evt.currentTarget.getAttribute('data-tab'));
      }
    );
    swat.initializeSFLList(
      sfl =>{ 
        swat.sflLid = sfl.listid;
      }, 
      err => console.log(err)
    );
  } else $('.page-custom-sfl-tab__button').addClass('swym-hide-container');

  // call on page load
  const lists = await getLists();
  if (lists.length > 0) {
    showListings(lists);
  } else {
    showEmptyState();
  }
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderWishlistPage);
